export enum ColorPalettes {
    RAL,
    Library
}